import styled, { css } from 'styled-components';

const baseTextStyle = css`
	font-variant-numeric: lining-nums tabular-nums;
	font-family: Inter;
	font-size: 0.75rem;
	font-weight: 400;
	line-height: 1rem;
`;

export const PopoverContainer = styled.div<{ $wide?: boolean }>`
	display: inline-flex;
	padding: 0.5rem;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;
	border-radius: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[0]};
	background: ${({ theme }) => theme.v3.colors.white[0]};
	box-shadow: 0 1rem 2rem 0 rgba(0, 0, 0, 0.08);
	min-width: ${({ $wide }) => ($wide ? '25rem' : '12.5rem')};
`;

export const PopoverTitle = styled.span`
	${baseTextStyle}
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	font-weight: 600;
`;

export const ItemsGrid = styled.div<{ $columns: string; $centerContent?: boolean }>`
	display: grid;
	grid-template-columns: ${({ $columns }) => $columns};
	gap: 0 0.75rem;
	padding: 0.25rem;
	border-radius: 0.25rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	background: ${({ theme }) => theme.v3.colors.gray[0]};
	width: 100%;
	align-items: center;
	justify-content: ${({ $centerContent }) => ($centerContent ? 'center' : 'start')};
`;

export const SecurityName = styled.span`
	${baseTextStyle}
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	text-align: left;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const UnitsText = styled.span`
	${baseTextStyle}
	color: ${({ theme }) => theme.v3.colors.dark[0]};
	text-align: right;
	white-space: nowrap;
`;

export const PriceLink = styled.span`
	${baseTextStyle}
	color: ${({ theme }) => theme.v3.colors.blue[6]};
	text-decoration-line: underline;
	text-decoration-style: solid;
`;

export const TotalAmount = styled.span`
	${baseTextStyle}
	color: ${({ theme }) => theme.v3.colors.dark[9]};
	text-align: right;
	white-space: nowrap;
`;

// Reserves the horizontal space of `)` after positive numbers so the digits
// line up with negative values (which the formatter wraps in parentheses).
export const ParenFiller = styled.span`
	visibility: hidden;
`;

export const TotalRowSeparator = styled.div`
	grid-column: 1 / -1;
	border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	margin: 0.125rem 0;
`;

const totalRowCellStyle = css`
	${baseTextStyle}
	font-weight: 600;
	color: ${({ theme }) => theme.v3.colors.dark[9]};
	white-space: nowrap;
`;

export const TotalRowLabel = styled.span`
	${totalRowCellStyle}
	text-align: left;
`;

export const TotalRowAmount = styled.span`
	${totalRowCellStyle}
	text-align: right;
`;
